

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Box from "@mui/material/Box";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { memo } from "react";
import { Link } from "react-router-dom";

function ComplexStatisticsCard({ color, title, count, percentage, icon, link, titletext, titletext1, titletext2, titletext3 }) {

  return (

    <Card sx={{ height: "100%", minHeight: "22vh" }}>
      <MDBox pt={1} px={2} >
        <MDBox
          variant="gradient"
          bgColor={color}
          color={color === "light" ? "dark" : "white"}
          coloredShadow={color}
          borderRadius="xl"
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="2.5rem"
          height="2.5rem"
          mt={-3}
        >
          <Icon fontSize="small" color="inherit">
            {icon}
          </Icon>
        </MDBox>
        <MDBox textAlign="right" lineHeight={1.25}>
          <MDTypography style={{ fontSize: "12px" }} variant="button" fontWeight="light" color="text">
            {title}
          </MDTypography>

          {(link && parseFloat(count) > 0) ?
            <Link to={link}>
              <MDTypography style={{ fontSize: "12px", textDecoration: "", cursor: "pointer" }} variant="h4">{`${count ? '' + count : ''}`}</MDTypography>
            </Link> :
            <MDTypography style={{ fontSize: "12px" }} variant="h4">{count}</MDTypography>}
          <Box>
            <MDTypography style={{ fontSize: "12px" }} variant="button" fontWeight="light" color="text">
              {titletext}
            </MDTypography>
          </Box>
          <Box>
            <MDTypography style={{ fontSize: "12px" }} variant="button" fontWeight="light" color="text">
              {titletext1}
            </MDTypography>
          </Box>
          <Box>
            <MDTypography style={{ fontSize: "12px" }} variant="button" fontWeight="light" color="text">
              {titletext2}
            </MDTypography>
          </Box>
          <Box>
            <MDTypography style={{ fontSize: "12px" }} variant="button" fontWeight="light" color="text">
              {titletext3}
            </MDTypography>
          </Box>
        </MDBox>
      </MDBox>
      {/* <Divider /> */}
      <MDBox pb={0.9} px={2}>
        <MDTypography component="p" variant="button" color="text" display="flex">
          <MDTypography
            component="span"
            variant="button"
            fontWeight="bold"
            style={{ fontSize: "12px" }}
            color={percentage.color}
          >
            {percentage.amount}
          </MDTypography>
          &nbsp;{percentage.label}
        </MDTypography>
      </MDBox>
    </Card>

  );
}

// Setting default values for the props of ComplexStatisticsCard
ComplexStatisticsCard.defaultProps = {
  color: "info",
  percentage: {
    color: "success",
    text: "",
    label: "",
  },
};

// Typechecking props for the ComplexStatisticsCard
ComplexStatisticsCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  percentage: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "white",
    ]),
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  }),
  icon: PropTypes.node.isRequired,
};

// export default ComplexStatisticsCard;
export default memo(ComplexStatisticsCard);
